import { render, staticRenderFns } from "./MerchantChannelStatistics.vue?vue&type=template&id=357234c4&"
import script from "./MerchantChannelStatistics.vue?vue&type=script&lang=ts&"
export * from "./MerchantChannelStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MerchantChannelStatistics.vue"
export default component.exports